<div class="w-full h-full px-5 py-3 flex flex-col justify-between gap-5">
  <div class="flex justify-between items-center">
    <div class="text-2xl font-semibold">
      {{ 'general.fileDetails' | translate }}
    </div>
    <button mat-icon-button class="float-right -mt-3 -mr-3" (click)="dialogRef.close()">
      <mat-icon class="text-primary mb-1">close</mat-icon>
    </button>
  </div>
  @if (isLoadingConfigFileDetails) {
    <div class="flex flex-col gap-5 h-full overflow-auto">
      <div class="bg-surface rounded-xl px-3 py-6 flex justify-between gap-2">
        <div class="flex shrink items-center">
          <mat-icon
            class="text-neutral tab-item__icon flex-none text-[60px]"
            style="width: 60px; height: 60px"
          >
            description
          </mat-icon>
        </div>
        <div class="w-[40%]">
          <div class="text-[20px] font-bold">
            {{ 'settings.configFiles.content.table.fileName' | translate }}
          </div>
          <div class="text-body-md text-neutral">
            <xemex-skeleton-block></xemex-skeleton-block>
          </div>
        </div>
        <div class="flex items-center gap-2 w-[30%]">
          <xemex-skeleton-block></xemex-skeleton-block>
        </div>
        <div class="flex flex-col items-end gap-2 w-[30%]">
          <xemex-skeleton-block></xemex-skeleton-block>
          <xemex-skeleton-block></xemex-skeleton-block>
        </div>
      </div>
      <div>
        <div class="grid grid-cols-3 gap-4 mt-7">
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.description' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.device' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.deviceConfigFiles.dialog.details.channelTypeId' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.firmwareVersions' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.partners' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.deviceConfigFiles.dialog.details.dynamicParameters' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.isDeleted' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              <xemex-skeleton-block></xemex-skeleton-block>
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2 mt-4">
          <div class="text-[20px] font-bold">
            {{ 'settings.configFiles.dialog.details.versions' | translate }}
          </div>
          <xemex-skeleton-block [height]="'200px'"></xemex-skeleton-block>
        </div>
      </div>
    </div>
  } @else {
    <div
      class="flex flex-col gap-5 h-full overflow-auto"
      [@versionChange]="$safeNavigationMigration(currentFileVersion?.versionId)"
    >
      <div class="bg-surface rounded-xl px-3 py-6 flex justify-between gap-2">
        <div class="flex shrink items-center">
          <mat-icon
            class="text-neutral tab-item__icon flex-none text-[60px]"
            style="width: 60px; height: 60px"
          >
            description
          </mat-icon>
        </div>
        <div class="w-[40%]">
          <div class="text-[20px] font-bold">
            {{ configFileDetails?.fileName }}
          </div>
          <div class="text-body-md text-neutral">version: {{ currentFileVersion?.versionId }}</div>
        </div>
        <div class="flex items-center gap-2 w-[30%]">
          <span class="text-ellipsis overflow-hidden">{{ currentFileVersion?.createdBy }} </span>
        </div>
        <div class="flex flex-col items-end gap-2 w-[30%]">
          <div class="text-body-md text-center">
            {{ currentFileVersion?.createdOn?.split('T')?.[0] ?? '' }}
          </div>
          <div class="text-body-md text-center">
            {{ currentFileVersion?.createdOn?.split('T')?.[1]?.split('.')?.[0] ?? '' }}
          </div>
        </div>
      </div>
      <div>
        <div class="grid grid-cols-3 gap-4 mt-7">
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.description' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ currentFileVersion?.description }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.device' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ currentFileVersion?.deviceType }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.deviceConfigFiles.dialog.details.channelTypeId' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ currentFileVersion?.channelTypeId }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.firmwareVersions' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ currentFileVersion?.firmwareVersions?.join(', ') || '-' }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.partners' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ partnerNames }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.deviceConfigFiles.dialog.details.dynamicParameters' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ dynamicParameterNames }}
            </div>
          </div>
          <div class="flex flex-col gap-2">
            <div class="text-[20px] font-bold">
              {{ 'settings.configFiles.dialog.details.isDeleted' | translate }}
            </div>
            <div class="text-body-md text-neutral">
              {{ (currentFileVersion?.isDeleted ? 'general.yes' : 'general.no') | translate }}
            </div>
          </div>
        </div>
        <div class="flex flex-col gap-2 mt-4">
          <div class="text-[20px] font-bold">
            {{ 'settings.deviceConfigFiles.dialog.details.previousVersions' | translate }}
          </div>
          <div>
            <div class="flex flex-col">
              <div
                class="flex bg-neutral px-4 py-2 text-white text-[12px] rounded-tl-lg rounded-tr-lg"
              >
                <div class="w-1/5">
                  {{ 'settings.configFiles.dialog.details.version' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.configFiles.dialog.details.isDeleted' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.configFiles.dialog.details.description' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.configFiles.dialog.details.uploaded' | translate }}
                </div>
                <div class="w-1/5">
                  {{ 'settings.configFiles.dialog.details.user' | translate }}
                </div>
              </div>
              @for (version of configFileDetails?.versions; track version) {
                <div
                  class="flex items-center px-4 py-2 bg-surface text-[10px] rounded-bl-lg rounded-br-lg"
                >
                  <div
                    class="w-1/5 text-primary cursor-pointer hover:underline"
                    (click)="onVersionClicked($safeNavigationMigration(version?.versionId))"
                  >
                    {{ version?.versionId }}
                  </div>
                  <div class="w-1/5">
                    {{ (version?.isDeleted ? 'general.yes' : 'general.no') | translate }}
                  </div>
                  <div class="w-1/5">
                    {{ version?.description }}
                  </div>
                  <div class="w-1/5">
                    {{ version?.createdOn?.split('T')?.[0] ?? '' }}
                  </div>
                  <div class="w-1/5">
                    {{ version?.createdBy }}
                  </div>
                </div>
              }
            </div>
          </div>
        </div>
      </div>
    </div>
  }

  <div class="flex justify-between">
    <div class="flex justify-start gap-2">
      <xemex-outlined-button intent="destructive" (click)="onDelete()" [disabled]="isDeletingFile">
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDelete' | translate }}</span>
          @if (isDeletingFile) {
            <xemex-spinner size="sm"></xemex-spinner>
          }
        </div>
      </xemex-outlined-button>
      <xemex-outlined-button (click)="onDownload()" [disabled]="isDownloadingFile">
        <div class="flex">
          <span class="mr-2">{{ 'general.btnDownload' | translate }}</span>
          @if (isDownloadingFile) {
            <xemex-spinner size="sm"></xemex-spinner>
          }
        </div>
      </xemex-outlined-button>
    </div>

    <xemex-filled-button class="float-right" (click)="dialogRef.close()">
      {{ 'general.btnClose' | translate }}
    </xemex-filled-button>
  </div>
</div>
